import { render, staticRenderFns } from "./RoleBlankView.vue?vue&type=template&id=ccd9f8da"
import script from "./RoleBlankView.vue?vue&type=script&lang=js"
export * from "./RoleBlankView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports